import { queryParams } from "../../../utils/queryParams";

export default {
  START_FROM_OPTIONS: [
    { id: "leads", name: "Lead (Profile Creation)" },
    { id: "appointments", name: "Appointment (First Booking)" },
    { id: "shows", name: "Show (First Visit)" },
    { id: "enrollments", name: "Enrollment (First Qualifying Purchase)" },
    { id: "intro_offer", name: "Intro Offer (Introductory Offer Purchase)" }
  ],

  AVERAGE_OPTIONS: ["Not Selected", "Brand", "User Access"],

  GROUP_OPTIONS: ["Brand", "Division", "District", "Region"],

  DEFAULT_GROUP: "Brand",
  USER_ACCESS: "User Access",
  API_STORE: "Store",
  API_NETWORK: "Network",

  FIRST_CONTACT_TYPE_OPTIONS: [
    { id: "hours", name: "Hour" },
    { id: "minutes", name: "Minute" }
  ],

  REQUEST_HREF: {
    FUNNEL_LASER_CHART: `${queryParams.apiVersion}pages/sales_activity/laser/funnel_laser_chart/get_chart`,
    FUNNEL_INTRO_OFFER: `${queryParams.apiVersion}pages/sales_activity/laser/funnel_laser_chart/get_start_from_intro`,
    FUNNEL_TABLE: `${queryParams.apiVersion}pages/sales_activity/laser/funnel_laser_chart/referrals`,
    FUNNEL_LASER_CHART_FILTERS: `${queryParams.apiVersion}pages/sales_activity/laser/funnel_laser_chart/get_filters`
  }
};
